/** @format */

export default {
    HOTEL_ONLY: {
        limit: 20, // hotels API limit for hotels flow
        range: 50,
    },
    VIEWS: {
        list: 'list',
        map: 'map',
    },
};
